import { render, staticRenderFns } from "./CmgSustainabilityInfoSection.vue?vue&type=template&id=5aa1298c&scoped=true&lang=pug&"
import script from "./cmg-sustainability-info-section.ts?vue&type=script&lang=ts&"
export * from "./cmg-sustainability-info-section.ts?vue&type=script&lang=ts&"
import style0 from "./CmgSustainabilityInfoSection.vue?vue&type=style&index=0&id=5aa1298c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa1298c",
  null
  
)

export default component.exports